import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'gp-back-link',
  templateUrl: './back-link.component.html',
  styleUrls: ['./back-link.component.scss']
})
export class BackLinkComponent {
  @Input()
  public linkText: string;

  @Output() linkClick = new EventEmitter<null>();

  public onLinkClick() {
    this.linkClick.emit(null);
  }
}
